import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { Editor as TF } from '../../features/treatments'
import { ROUTE_TREATMENTS } from '../../routes/routes-constants'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

type TreatmentFormProps = {
  userID?: string
} & RouteProps

export function TreatmentsForm(props: TreatmentFormProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)
  const state: TreatmentFormProps = props.location?.state as TreatmentFormProps

  return <TF id={props.id === ROUTE_TREATMENTS ? undefined : props.id} userID={state?.userID} />
}
